import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "M15.755 16.484a.75.75 0 0 1 1.061.02l3.458 3.6c.144.15.213.345.208.538a.75.75 0 0 1-.302.594l-.064.042-.45.256C15.095 24 8.699 23.823 4.211 21.525l-.442-.236-.065-.041a.75.75 0 0 1-.135-1.104 1 1 0 0 1 .076-.092l3.441-3.55a.75.75 0 1 1 1.078 1.044l-2.79 2.876c3.907 1.799 9.231 1.911 13.14.016l-2.78-2.894-.049-.058a.75.75 0 0 1 .07-1.002"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M13.292 1.985a2.91 2.91 0 0 1 2.905 2.916V7.29l.471.244a.75.75 0 0 1-.471 1.395v5.523a1.83 1.83 0 0 1-1.828 1.833H9.631a1.83 1.83 0 0 1-1.828-1.833V8.931a.75.75 0 0 1-.487-1.387l.487-.268V4.901a2.91 2.91 0 0 1 2.906-2.916zm1.405 11.129c-.84.295-1.762.45-2.673.463a8.2 8.2 0 0 1-2.722-.407v1.282a.33.33 0 0 0 .328.333h4.738a.33.33 0 0 0 .328-.333v-1.338zm0-4.817c-1.698-.572-3.702-.604-5.395-.025v3.284c.777.356 1.725.536 2.699.521s1.922-.22 2.695-.581zm-3.988-4.812a1.41 1.41 0 0 0-1.406 1.416v1.801c1.742-.485 3.672-.456 5.395.025V4.901a1.41 1.41 0 0 0-1.405-1.416z"
}));
const ForwardRef = forwardRef(SvgComponent);
export const BackupCameraIcon = ForwardRef;